const address = {
  Name: "Name",
  Address: "Address",
  ShippingAddresses: "Shipping addresses",
  PatientAddresses: "Patient addresses",
  Default: "Default address",
  Saved: "Saved addresses",
  Tooltip:
    "For quicker checkout, your default shipping address will be used for all express checkout transactions. It can be updated at any time.",
  AddAddress: "Add Address",
  Empty: {
    Title: "No shipping addresses added",
    Description: "Once a shipping address is added, it can be managed here.",
  },
  EmptyPatient: {
    Title: "No patient addresses added",
    Description: "Once a patient address is added, it can be managed here.",
  },
  Search: {
    Patient: "Search patient",
    ShippingAddress: "Search shipping address",
    NoResults: "Clear your search or try to search another name or address.",
  },
  Fields: {
    FirstName: "First name",
    LastName: "Last name",
    Address1: "Address 1",
    Address2: "Address 2",
    Country: "Country",
    State: "State",
    City: "City",
    PostalCode: "Zip",
    SetDefault: "Set as default",
  },
  AddressSaved: "Shipping address saved successfully",
  PatientAddressSaved: "Patient address saved successfully",
  AddressHasBeenDeleted: "Address has been deleted!",
  DeleteAddress: "Delete address?",
  AddressActionCantUndo: "Addresses cannot be restored once they are removed",
  DeleteShippingAddressError:
    "An error occurred while trying to remove your shipping address. Please try again.",
  DeletePatientAddressError:
    "An error occurred while trying to remove your patient address. Please try again.",
};

export { address };
